// KAURI
import kauri1 from '../assets/images/kauri/1.jpeg';
import kauri2 from '../assets/images/kauri/2.jpeg';
import kauri3 from '../assets/images/kauri/3.jpeg';
import kauri4 from '../assets/images/kauri/4.jpeg';
import kauri5 from '../assets/images/kauri/5.jpeg';
import kauri6 from '../assets/images/kauri/6.jpeg';
import kauri7 from '../assets/images/kauri/7.jpeg';
import kauri8 from '../assets/images/kauri/8.jpeg';
import kauri9 from '../assets/images/kauri/9.jpeg';
import kauri10 from '../assets/images/kauri/10.jpeg';
import kauri11 from '../assets/images/kauri/11.jpeg';
import kauri12 from '../assets/images/kauri/12.jpeg';
import kauri13 from '../assets/images/kauri/13.jpeg';
import kauri14 from '../assets/images/kauri/14.jpeg';
// MANUKA
import manuka2 from '../assets/images/manuka/2.jpeg';
import manuka3 from '../assets/images/manuka/3.jpeg';
import manuka4 from '../assets/images/manuka/4.jpeg';
import manuka5 from '../assets/images/manuka/5.jpeg';
import manuka6 from '../assets/images/manuka/6.jpeg';
import manuka7 from '../assets/images/manuka/7.jpeg';
import manuka8 from '../assets/images/manuka/8.jpeg';
import manuka9 from '../assets/images/manuka/9-outside.jpeg';
// KARAKA
import karaka1 from '../assets/images/karaka/1.jpeg';
import karaka2 from '../assets/images/karaka/2.jpeg';
import karaka3 from '../assets/images/karaka/3.jpeg';
import karaka4 from '../assets/images/karaka/4.jpeg';
import karaka5 from '../assets/images/karaka/5.jpeg';
import karaka6 from '../assets/images/karaka/6.jpeg';
import karaka7 from '../assets/images/karaka/7.jpeg';
import karaka8 from '../assets/images/karaka/8.jpeg';
// KOWHAI
import kowhai1 from '../assets/images/kowhai/1.jpeg';
import kowhai2 from '../assets/images/kowhai/2.jpeg';
import kowhai3 from '../assets/images/kowhai/3.jpeg';
import kowhai4 from '../assets/images/kowhai/4.jpeg';
import kowhai5 from '../assets/images/kowhai/5.jpeg';
import kowhai6 from '../assets/images/kowhai/6.jpeg';
import kowhai7 from '../assets/images/kowhai/7.jpeg';
import kowhai8 from '../assets/images/kowhai/8.jpeg';
import kowhai9 from '../assets/images/kowhai/9.jpeg';
import kowhai10 from '../assets/images/kowhai/10.jpeg';
import kowhai11 from '../assets/images/kowhai/11.jpeg';
import kowhai12 from '../assets/images/kowhai/12.jpeg';
import kowhai13 from '../assets/images/kowhai/13.jpeg';
import kowhai14 from '../assets/images/kowhai/14.jpeg';
import kowhai15 from '../assets/images/kowhai/15.jpeg';
import kowhai16 from '../assets/images/kowhai/16.jpeg';
import kowhai17 from '../assets/images/kowhai/17.jpeg';
import kowhai18 from '../assets/images/kowhai/18.jpeg';
// ALL
import layout from '../assets/images/general/1-layout.jpg'


const suiteData = [
  {
    name: 'Kauri',
    images: [kauri1, kauri2, kauri3, kauri4, kauri5, kauri6, kauri7, kauri8, kauri9, kauri10, kauri11, kauri12, kauri13, kauri14, layout],
    short: "Kauri is a serene and comfortable space with beautiful views Matiatia Bay.",
    description: 'Kauri Suite offers breathtaking, uninterrupted views of the sea and bushland, with stunning sunsets stretching across the Bay to Motuihe Island and beyond. The interior boasts muted furnishings and thoughtful touches, creating a serene and comfortable space. High ceilings and expansive sliding doors lead to your own private balcony, enhancing the sense of openness and tranquility.',
    sleep: "2",
    amenities: [
      'Queen Bed',
      'Private Balcony',
      'BBQ',
      'Equipped Kitchenette',
      'Outdoor Dining',
      'Wi-Fi',
      'Smart TV',
      'Washer/Dryer',
      'Wheelchair accessible',
      'Onsite Parking'
    ],
    price: "NZ$180-$400",
    href: 'https://www.staywaiheke.com/holiday-homes/delamore-cove-kauri',
  },
  {
    name: 'Manuka',
    images: [manuka9, manuka2, manuka3, manuka4, manuka5, manuka6, manuka7, manuka8, layout],
    short: "Manuka features sophisticated furnishings and thoughtful touches with beautiful views Matiatia Bay.",
    description: 'Manuka Suite offers breathtaking, uninterrupted views of the sea and bushland, with stunning sunsets that span the Bay to Motuihe Island and beyond. The interior features sophisticated furnishings and thoughtful touches, creating a serene and comfortable atmosphere. High ceilings and large sliding doors open onto your private balcony, enhancing the sense of space and calm.',
    sleep: "2",
    amenities: [
      'Queen Bed',
      'Private Balcony',
      'BBQ',
      'Equipped Kitchenette',
      'Outdoor Dining',
      'Wi-Fi',
      'Smart TV',
      'Washer/Dryer',
      'Wheelchair accessible',
      'Onsite Parking'
    ],
    price: "NZ$180-$400",
    href: 'https://www.staywaiheke.com/holiday-homes/delamore-cove-manuka',

  },
  {
    name: 'Karaka',
    images: [karaka3, karaka1, karaka2, karaka4, karaka5, karaka6, karaka7, karaka8, layout],
    short: "Spacious light-filled interior with Breathtaking views of Matiatia Bay.",
    description: "The Karaka Studio embodies the essence of New Zealand's local flora and natural beauty. The spacious, light-filled interior features high ceilings, a comfortable queen-size bed with a walk-in wardrobe, and an ensuite with heated flooring, all contributing to a luxurious feel. While the suite does not have a balcony, it offers a beautiful area with outdoor furniture, providing serene views of the garden—perfect for enjoying your morning coffee or an afternoon glass of wine. Thoughtful touches throughout the studio create a space with a true sense of style and comfort.",
    // 'The Karaka Studio embodies the essence of New Zealand\'s local flora and natural beauty. The spacious, light-filled interior features high ceilings, a comfortable queen-size bed with a walk-in wardrobe, and an ensuite with heated flooring, all contributing to a luxurious feel. Enjoy your morning coffee or afternoon glass of wine on the outdoor furniture, with serene views of the garden. Thoughtful touches throughout the studio create a space with a true sense of style and comfort.',//
    sleep: "2",
    amenities: [
      'Queen Bed',
      'Wi-Fi',
      'Smart TV',
      'Microwave',
      'Toaster',
      'Tea and Coffee amenities',
      'Bar Refrigerator',
      'Wheelchair accessible',
      'Onsite Parking'
    ],
    price: "NZ$150-$350",
    href: 'https://www.staywaiheke.com/holiday-homes/delamore-cove-karaka',
  },
  {
    name: 'Kowhai',
    images: [kowhai1, kowhai2, kowhai3, kowhai4, kowhai5, kowhai6, kowhai7, kowhai8, kowhai9, kowhai10, kowhai11, kowhai12, kowhai13, kowhai14, kowhai15, kowhai17, kowhai18, kowhai16, layout],
    short: "Ideal for families, Kowhai sleeps 4. Features stunning views of Matiatia Bay and a private covered porch.",
    description: 'Ideal for families, Kowhai features a private covered porch and a BBQ area, perfect for outdoor gatherings. The well-equipped kitchenette has everything you need for a cozy evening in or an extended stay. The master bedroom offers a comfortable queen bed, while the second bedroom includes a bunk bed with a double bed on the bottom and a single on top. Please note: Access to the bathroom and porch is through the second bedroom.',
    sleep: "4",
    amenities: [
      'Two Bedrooms: 1 Queen Bed, Double Bed & Single Bunk Bed',
      'Private Patio',
      'BBQ',
      'Equipped Kitchenette',
      'Outdoor Dining',
      'Wi-Fi',
      'Smart TV',
      'Washer/Dryer',
      'Wheelchair accessible',
      'Onsite Parking'
    ],
    price: "NZ$250-$525",
    href: 'https://www.staywaiheke.com/holiday-homes/delamore-cove-kowhai',
  }
];

export default suiteData;



